import { ArrowBackIosNewRounded, ArrowForwardIosOutlined, ArrowForwardIosRounded, ArrowForwardRounded } from "@mui/icons-material";
import { Avatar, IconButton, Stack, Typography, Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { useTestimonialsData } from "../../hooks/useTestimonialsData";
import { useEffect, useRef, useState } from "react";



const accentColors = ["#ff6f61", "#4a90e2", "#7ed321", "#f5a623","#9BB4C0"];
const TestimonailCard = ({item, isSiteBuilder, theme, index}) => {


const accent = accentColors[index % accentColors.length];

  return(
    <motion.div 
		whileHover = {{y : -6,boxShadow: "0 12px 24px rgba(0,0,0,0.1)"}}
		style={{
			position:"relative",
			borderRadius: 12,
			background: theme.palette.background.paper,
			padding: theme.spacing(5),
			height: 340,
			display:"flex",
			flexDirection:"column",
			border:"1px solid #ddd",
			justifyContent:"space-between",
			boxShadow:
			theme.palette.mode === "light"
				? "0 6px 14px rgba(0,0,0,0.06)"
				: "0 8px 16px rgba(0,0,0,0.25)",
			transition: "transform 0.3s ease",
      	}}
	>
		<Box sx={{position: "absolute",top: 0,left: 0,height: 4,width: "100%",backgroundColor: accent}}/>
		
		<Typography sx={{lineHeight: 1.75,fontStyle: "italic",marginBottom: 2,overflow: "hidden",display: "-webkit-box",WebkitLineClamp: 6,WebkitBoxOrient: "vertical"}}>
			{!isSiteBuilder ? item?.t_text : "“Exceptional collaboration and results — this experience raised our expectations.”"}
		</Typography>

		<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
			<Typography variant="subtitle1" fontWeight={'bold'}>
				{!isSiteBuilder ? item?.t_name : "Learner Name"}
			</Typography>
			<Avatar
				src={!isSiteBuilder? item?.t_image : ""}
				sx={{width: 64, height : 64}}
			/>
		</Stack>

    </motion.div>
  );
};

const CustomTestimonials2 = () => {

	const {reducer} 		= useSelector((state) => state);
	const {isSiteBuilder}	= reducer;
	const theme				= useTheme();
	const scrollRef 		= useRef(null);

	const [testimonialData, setTestimonialData] = useState([]);


	const getTestimonail = async () => {

		const results = await useTestimonialsData();
		setTestimonialData(results);
	}

	useEffect (()=> {
		if (!isSiteBuilder){
			getTestimonail();
		}
	}, [isSiteBuilder])

	const dataToShow = isSiteBuilder ? Array(6).fill({t_text : "", t_image : "", t_name : ""}) : testimonialData?.length ? testimonialData : [];
	
	const scrollLeft = () => {
		 scrollRef.current.scrollBy({left : 350, behaviour : "smooth"})
	}

	const scrollRight = ()=> {
		scrollRef.current.scrollBy({left : -350, behaviour:"smooth"})
	} 

	return(

		<Stack position={'relative'}>
			<IconButton
				onClick={scrollRight}
				sx={{
					position: "absolute",
					top: "50%",
					left: -20,
					transform: "translateY(-50%)",
					zIndex: 10,
					boxShadow: "0 4px 12px rgba(0,0,0,0.15)",

				}}
			>
				<ArrowBackIosNewRounded/>
			</IconButton>
			<Stack 
				ref= {scrollRef}
				direction={'row'} 
				gap={4} 
				sx={{
					overflowX: "auto",
					scrollBehavior: "smooth",
					"&::-webkit-scrollbar": { display: "none" },
				}}
			>
				{dataToShow.map((item, index)=> (
					<Box
						key={index}
						sx={{ minWidth: 300,flex: "0 0 calc(33% - 100px)",}}
					>
						<TestimonailCard
							item={item}
							isSiteBuilder={isSiteBuilder}
							theme ={theme}
							index={index}
						/>
					</Box>
				))}
			</Stack>
			<IconButton
				onClick={scrollLeft}
				 sx={{
					position: "absolute",
					top: "50%",
					right: -20,
					transform: "translateY(-50%)",
					zIndex: 10,
					boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
				}}
			>
				<ArrowForwardIosRounded/>
			</IconButton>
		</Stack>

		
				
	)

}

export default CustomTestimonials2;